import React, { useState } from 'react'
import {
  StyledCardImage,
  StyledCardImageFallback,
  StyledCardImageStack,
  StyledCardOpenLayer,
  StyledCardPlaceholder,
} from '../ConciergeCardTile/styled'
import { system as s } from '@moonpig/launchpad-system'
import { IconSystemPencil } from '@moonpig/launchpad-assets'
import { styled } from '@moonpig/launchpad-utils'
import { IconButton } from '@moonpig/launchpad-components'
import { useLocaleText } from '../../locale'

type ConciergeCardTileContentProps = {
  imageUrl?: string
  title: string
  onTileClick: () => void
}

const StyledCallToAction = styled(IconButton)`
  ${s({
    position: 'absolute',
    bgcolor: 'colorInteractionButton',
    borderRadius: 40,
    width: 40,
    height: 40,
    p: 4,
    bottom: 8,
    right: 8,
    color: 'colorBlack00',
  })}
  z-index: 1;

  &:hover:not(.loading) {
    ${s({
      bgcolor: 'colorInteractionButtonHover',
      color: 'colorBlack00',
    })}
  }
`

export const ConciergeCardTileContent = ({
  imageUrl,
  title,
  onTileClick,
}: ConciergeCardTileContentProps) => {
  const localiseText = useLocaleText()
  const [hasImageError, setHasImageError] = useState(false)

  if (!imageUrl || hasImageError) {
    return (
      <StyledCardPlaceholder>
        <StyledCardImageFallback>Failed to load image</StyledCardImageFallback>
      </StyledCardPlaceholder>
    )
  }

  return (
    <StyledCardPlaceholder>
      <StyledCardImageStack>
        <StyledCardOpenLayer aria-hidden="true" />
        <StyledCardImage
          alt={title}
          aria-hidden="true"
          draggable={false}
          src={imageUrl}
          onError={() => setHasImageError(true)}
        />
      </StyledCardImageStack>
      <StyledCallToAction
        icon={IconSystemPencil}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          onTileClick()
        }}
        label={localiseText('concierge_chat.view_card_label')}
      />
    </StyledCardPlaceholder>
  )
}
